import React, { memo } from "react";
import ResearchContent from "./ResearchContent";
import DocumentPagination from "./DocumentPagination";
import Typography from "../../components/Typography/Typography";
import Loader from "../../components/Loader/Loader";

export default memo(function ResearchChatView({
    selectedChat,
    selectedDocumentsChat,
    searchResponses,
    currentPrompt,
    containerRef,
    latestSearchResultRef,
    handleSearch,
    loading
}) {
    const isMobile = window.innerWidth < 768;

    if (selectedChat) {
        return (
            <div className="flex md:flex-row flex-col-reverse w-full gap-0 bg-gray-50 h-fit border-gray-150 relative">
                {/* Left Column: Chat content */}
                <div
                    className="md:w-2/3 w-full pt-2 md:pt-12 flex flex-col gap-4 border-r-2 border-b-2 border-gray-150 relative overflow-y-auto"
                    ref={containerRef}
                >
                    <ResearchContent
                        textExample={selectedChat}
                        searchFunction={handleSearch}
                        isLatestResponse={false}
                    />
                </div>
                {/* Right Column: Sources */}
                <DocumentPagination response={selectedDocumentsChat} />
            </div>
        );
    }

    return (
        <>
            {searchResponses.map((response, respIndex) => {
                return (
                    <div
                        key={respIndex}
                        ref={respIndex === searchResponses.length - 1 ? latestSearchResultRef : null}
                        className="flex md:flex-row flex-col-reverse w-full gap-0 bg-gray-50 h-fit border-gray-150 relative"
                    >
                        <div
                            className={`md:w-2/3 w-full pt-2 md:pt-12 md:pb-10 ${respIndex === searchResponses.length - 1 && !response.aiContent ? "pb-28" : "pb-0"
                                } flex flex-col gap-4 border-r-2 border-b-2 border-gray-150 relative`}
                        >
                            {response.aiContent ? (
                                <ResearchContent
                                    textExample={response.aiContent}
                                    searchFunction={handleSearch}
                                    isLatestResponse={respIndex === searchResponses.length - 1}
                                />
                            ) : (
                                <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 px-6 md:px-12">
                                    <div className="col-span-full lg:col-span-6 xl:col-span-4 flex flex-col gap-2 mb-4">
                                        <Typography size="48" family="serif" weight="sb">
                                            {currentPrompt || ""}
                                        </Typography>
                                        <div className="flex gap-3">
                                            <Loader size={isMobile ? 20 : 16} />
                                            <Typography size="16" dekstopSize="16" color="gray-600">
                                                Cercando tra milioni di documenti...
                                            </Typography>
                                        </div>
                                    </div>
                                    <div className="col-span-full lg:col-span-6 xl:col-span-4 rounded-[12px] bg-gray-100 animate-pulse h-44" />
                                    <div className="col-span-full lg:col-span-6 xl:col-span-4 rounded-[12px] bg-gray-100 animate-pulse h-10" />
                                    <div className="col-span-full lg:col-span-6 xl:col-span-4 rounded-[12px] bg-gray-100 animate-pulse h-[20rem] md:h-[50rem]" />
                                    <div className="col-span-full lg:col-span-6 xl:col-span-4 rounded-[12px] bg-gray-100 animate-pulse h-44" />
                                    <div className="col-span-full lg:col-span-6 xl:col-span-4 rounded-[12px] bg-gray-100 animate-pulse h-10" />
                                </div>
                            )}
                        </div>
                        <DocumentPagination response={response} />
                    </div>
                )
            })}
        </>
    );
});